<template>
    <div class="fullHeight">
    <MypageSideMenu :memberDropClose="false"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-info-profile mypage-title-icon"
    >
      <!-- 以下内容 -->
      <div class="col-sm-12">
        <div class="row py-2">
          <div class="col-lg-2">
              <label for="nickname">ニックネーム</label>
          </div>
          <div class="col-lg-4">
              <input v-model="nickname" class="form-control" id="nickname" />
          </div>
        </div>
        <div class="row py-2">
          <div class="col-lg-2">
            <label for="age">年代</label>
          </div>
          <div class="col-lg-2">
            <select v-model="era" class="form-control">
                <option v-for="option in eraSelect" v-bind:value="option.value" :key="option.text">
                    {{ option.text }}
                </option>
            </select>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-lg-2">
            <label for="scoreLevel">スコアレベル</label>
          </div>
          <div class="col-lg-2">
            <select v-model="scoreLevel" class="form-control">
                <option v-for="option in scoreLevelSelect" v-bind:value="option.value" :key="option.text">
                    {{ option.text }}
                </option>
            </select>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-lg-2">
            <label for="profile">プロフィール</label>
          </div>
          <div class="col-lg-10">
            <textarea v-model="profile" class="form-control" id="profile" rows="6" style="resize: none;"></textarea>
          </div>
        </div>
        <div class="row no-gutters justify-content-center py-2">
          <div class="col-sm-4 w-100">
              <button
                  class="bluebackbutton footer-btn-size"
                  :disabled="disabledCheck"
                  @click="checkForm"
                  v-if="modeStatus === 'addMode'">登&nbsp;&nbsp;録
              </button>
          </div>
        </div>
      </div>
    </Card>
    <MypageMenuFooter/>
    <ConfirmDialog
        v-if="dialog === true && this.modeStatus === 'addMode'"
        :initialMessage="registMessage"
        doing="登録"
        notDoing="閉じる"
        :processing="processing"
        @from-Dialog="registMyProfile"
        @closeBtn="addoverlayHidden"
      />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import MypageHeader from './MypageHeader';
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import { CODE_MASTER } from '../../config.js';
import {
  REGIST_MY_PROFILE,
  GET_MY_PROFILE } from '../../constants/mypage_profile';
import validater from "../../lib/validater";
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        Card,
        ConfirmDialog,
        validater
    },
    data () {
        return {
            // 会員番号
            memberNo: '',
            // フルネーム
            fullName: '',
            // ページタイトル
            page_title: 'プロフィール登録',
            // ニックネーム
            nickname: '',
            // 年代
            era: '',
            // スコアレベル
            scoreLevel: '',
            // プロフィール
            profile: '',
            // 確認ダイアログの表示フラグ
            dialog: false,
            // 画面のステータス（情報がある場合、'editMode'が入る）
            modeStatus: '',
            // 年代セレクトボックスの中身
            eraSelect: [
                { text: '', value: '' },
                { text: '10代以下', value:"0" },
                { text: '10代', value:"10" },
                { text: '20代', value:"20" },
                { text: '30代', value:"30" },
                { text: '40代', value:"40" },
                { text: '50代', value:"50" },
                { text: '60代', value:"60" },
                { text: '70代', value:"70" },
                { text: '80代', value:"80" },
                { text: '90代', value:"90" },
                { text: '100代', value:"100" }
            ],
            // スコアレベルセレクトボックスの中身
            scoreLevelSelect: [
                { text: '', value: '' },
                { text: '60台', value:"60" },
                { text: '70台', value:"70" },
                { text: '80台', value:"80" },
                { text: '90台', value:"90" },
                { text: '100台', value:"100" },
                { text: '110台', value:"110" },
                { text: '120台', value:"120" },
                { text: '130台', value:"130" },
                { text: '140台', value:"140" },
                { text: '150台以上', value:"150" },
            ],
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // /lang/message.json から読みこんだ登録メッセージ
            registMessage: this.$t("message.registProfile"),
            registBtn: this.$t("btn.regist"),
            golfGroupCode: process.env.MIX_GROUP_CODE,
        };
    },
    created () {
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        this.fullName = this.$store.state.auth.loginMember.family_name
                         + ' '
                         + this.$store.state.auth.loginMember.given_name;
        this.getMyProfile();
    },
    computed: {
        /** ----------------------------------------------
       * 登録ボタンのdisabled値を変更します。
       * @param  {Boolean}
       * ---------------------------------------------- */
        disabledCheck() {
            // ３つのインプットが空ならdiabeldにします。
            if (
                !this.era &&
                !this.scoreLevel &&
                !this.profile
            ) {
                return true; // ボタンクリック不可
            } else {
                return false; // ボタンクリック可
            }
        },
    },
    methods: {
        /** ----------------------------------------------
       * プロフィールを登録する
       * @param  {Number} memberNo - ログイン者のmemberNo
       * @return {String} processing.result - '1' or '0'
       * @return {String} processing.resultText - メッセージが返ります。
       * ---------------------------------------------- */
        registMyProfile () {
            this.$set(this.processing, 'btnDisabled', 1);
            this.$apollo.mutate({
                mutation: REGIST_MY_PROFILE,
                variables: {
                    member_no: this.memberNo,
                    nickname: this.nickname,
                    era: this.era,
                    score_level: this.scoreLevel,
                    profile: this.profile
                }
            }).then(res => {
                const result = res.data.registMyProfile.result;
                const resultText = res.data.registMyProfile.resultText;
                if (result === '1') {
                    this.$set(this.processing, 'result', 1);
                    this.$set(this.processing, 'resultText', resultText);
                } else if (result === 0) {
                    throw new Error(resultText);
                }
              this.$set(this.processing, 'btnDisabled', 0);
            }).catch(error => {
                const message = error.message.split(':');
                this.$set(this.processing, 'result', 0);
                this.$set(this.processing, 'resultText', message[1]);
                this.$set(this.processing, 'btnDisabled', 0);
            });
        },
        /** ----------------------------------------------
       * プロフィールを取得する
       * @param  {Number} memberNo - ログイン者のmemberNo
       * @return {String} era - 年代が返ります。
       * @return {String} scoreLevel - スコアレベルが返ります。
       * @return {String} profile - プロフィールが返ります。
       * ---------------------------------------------- */
        getMyProfile () {
          this.$apollo.query({
            query: GET_MY_PROFILE,
            fetchPolicy: 'no-cache',
            variables: {
              member_no: this.memberNo
            }
          }).then(res => {
            const data = res.data.getMyProfile.Profile[0];
            // console.log(data);
            // if (data) {
            this.modeStatus = 'addMode';
            this.era = data.era;
            this.nickname = data.nickname;
            this.scoreLevel = data.score_level;
            this.profile = data.profile;
            // }
            // else if (!data.era) {
            //     this.modeStatus = 'addMode';
            // }
          }).catch(error => {
              this.$set(this.processing, 'resultText', error);
          });
        },
        /** ----------------------------------------------
       * プロフィールを取得する
       * @return {String} dialog - 確認ダイアログの表示値を変更します。
       * @return {Boolean}
       * ---------------------------------------------- */
        checkForm (e) {
            if (this.era === null && this.scoreLevel === null && this.profile === null) {
                return false;
            } else {
                this.dialog = true;
                return true;
            }
            e.preventDefault();
        },
        /** ----------------------------------------------
       * 確認ダイアログを閉じる
       * @return {String} processing.result - ''に変更
       * @return {Boolean} dialog - 確認ダイアログの表示値を変更します。
       * ---------------------------------------------- */
        addoverlayHidden () {
          this.$set(this.processing, 'result', '');
          this.dialog = false;
        }
    }
}

</script>

<style scoped>
</style>
